import { Link } from "react-router-dom";

export const NotFound = () => {
  return (
    <div className="h-screen w-full flex flex-col items-center justify-center bg-gray-50">
      <h1 className="text-6xl font-bold text-gray-300">404</h1>
      <p className="text-lg text-gray-500 mt-4">
        Trang bạn tìm kiếm không tồn tại
      </p>
      <Link
        to="/"
        className="mt-6 px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-300"
      >
        Về trang chủ
      </Link>
    </div>
  );
};
